import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { ROLLING_TOKEN_HEADER, rollingToken } from "./rollingToken";

const abortController = new AbortController();

const httpLink = createHttpLink({
  // graphql_url declared in resources/react/types/index.ts
  uri: window.graphql_url ?? "https://werkstatt.repareo.de/graphql",
  credentials: "include",
  fetchOptions: {
    signal: abortController.signal,
  },
  headers: {
    "X-repareo-origin-actor": "Frontend: WLv1", // Used to track the origin of requests
  },
});

// Derived per operation rather than once at module load: a booking session outlives a token window.
const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      [ROLLING_TOKEN_HEADER]: rollingToken(),
    },
  };
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      Garage: { keyFields: ["id"] },
      GarageProperty: { keyFields: ["id"] },
      GeoSuggest: {
        keyFields: ["id"],
        fields: {
          lat: {
            merge: (existing: number | null, incoming: number | null) => incoming ?? existing,
          },
          lon: {
            merge: (existing: number | null, incoming: number | null) => incoming ?? existing,
          },
        },
      },
      GaragePropertyPaginator: { keyFields: false },
      GaragePaginator: {
        keyFields: false,
      },
      Organization: {
        keyFields: ["id"],
        fields: {
          garages: {
            keyArgs: [
              "id",
              "lat",
              "lon",
              "distance",
              "appointmentsFrom",
              "appointmentsTo",
              "services",
              "search",
              "sortBy",
              "premiumServices",
              "slug",
              "brand",
              "generation",
              "motorization",
              "gearbox",
              "body",
              "mileage",
              "registrationDate",
              "subRepairs",
              "equipments",
              "supportsBev",
              "supportsCommercialVehicles",
              "onlyBookable",
              "driverID",
              "garageTypes",
              "garageChains",
              "presetFilters",
              "garageProperties",
              "onlyPreferredPartners",
            ],
            // IMPORTANT: do not concatenate — always replace with the newest result
            merge(_existing, incoming) {
              return incoming;
            },
          },
        },
      },
    },
  }),
});
